import { render, staticRenderFns } from "./baseContent.vue?vue&type=template&id=1a654977&scoped=true&"
import script from "./baseContent.vue?vue&type=script&lang=js&"
export * from "./baseContent.vue?vue&type=script&lang=js&"
import style0 from "./baseContent.vue?vue&type=style&index=0&id=1a654977&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a654977",
  null
  
)

export default component.exports